var React = require('react');

function ReturnsExchanges (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.56372 5.08117L6.99604 2.15763C9.09948 1.00221 11.6891 1.0076 13.7871 2.17244L19.4686 5.08251L10.5161 10.3061L1.56372 5.08117Z","stroke":"#2D2927","strokeWidth":"1.59601","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M1.58123 12.2735L1.56372 5.07983L10.5161 10.3034V19.9925L4.10078 16.4373C2.54542 15.5755 1.58527 13.9905 1.58123 12.2735Z","stroke":"#2D2927","strokeWidth":"1.59601","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M19.451 12.2735L19.4685 5.07983L10.5161 10.3034V19.9925L16.9315 16.4373C18.4868 15.5755 19.447 13.9905 19.451 12.2735Z","stroke":"#2D2927","strokeWidth":"1.59601","strokeLinejoin":"round","key":2})]);
}

ReturnsExchanges.defaultProps = {"viewBox":"0 0 21 21"};

module.exports = ReturnsExchanges;

ReturnsExchanges.default = ReturnsExchanges;
